/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Business_Management18Inputs */

const en_cv_extract_form_enum_business_management18 = /** @type {(inputs: Cv_Extract_Form_Enum_Business_Management18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business and Management`)
};

const de_cv_extract_form_enum_business_management18 = /** @type {(inputs: Cv_Extract_Form_Enum_Business_Management18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betriebswirtschaft und Management`)
};

/**
* | output |
* | --- |
* | "Business and Management" |
*
* @param {Cv_Extract_Form_Enum_Business_Management18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_business_management18 = /** @type {((inputs?: Cv_Extract_Form_Enum_Business_Management18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Business_Management18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_business_management18(inputs)
	return en_cv_extract_form_enum_business_management18(inputs)
});
export { cv_extract_form_enum_business_management18 as "cv_extract_form_enum_BUSINESS_MANAGEMENT" }